<template>
  <div v-if="isChatEnabled && isChatAllowed">
    <div id="tdWebchat"></div>
  </div>
</template>

<script>
import chatsound from "@/assets/audio/chat-notification.wav";

export default {
  props: {
    isChatAllowed: {
      type: Boolean,
      default: false,
    },
    salesforceContactId: {
      type: String,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      webchat: null,
      notificationAudio: new Audio(chatsound),
      isAudioPlaying: false,
      lastMessageIndex: sessionStorage.getItem("lastProcessedMessageIndex") || null,
      isChatEnabled: this.$appConfig.isChatEnabled,
      chatStyles: {
        chatThemeColor: "#a83338",
        chatTitle: "TripCircuit Chat",
        userTextColor: "#FFFFFF",
        userBackgroundColor: "#a83338",
        userAnchorTextColor: "#E1CCFE",
        userAnchorTextColorVisited: "#B681FC",
        botTextColor: "#000000",
        botBackgroundColor: "#F2F4F5",
        botAnchorTextColor: "#3232D6",
        botAnchorTextColorVisited: "#5405BD",
        botIconVerticalAlign: "top",
        avatarBorderColor: "#EDF4FC",
        botIconHeight: "32px",
        botIconWidth: "32px",
        chatPlaceholder: "Type a message...",
        avatarForegroundColor: "#a83338",
        avatarBackgroundColor: "#FFFFFF",
        startChatButtonTextColor: "#FFFFFF",
        chatSubtitle: "powered by Gant Travel",
        chatSubtitleTextColor: "#FFFFFF",
        chatContainerWidth: "360px",
        chatContainerHeight: "500px",
        customButtonBorderColor: "#a83338",
        customButtonColor: "#FFFFFF",
        customButtonBackgroundColor: "#a83338",
        customButtonFontFamily: "Helvetica",
        chatHoverThemeColor: "#8c3334",
        startChatButtonBackgroundColor: "#A83338",
        startChatButtonHoverBackgroundColor: "#8c3334",
        triggerButtonPositionBottom: null,
      },
      scriptLoaded: false, // Tracks if the script has been loaded
    };
  },
  mounted() {
    if (this.isChatEnabled && this.isChatAllowed) {
      this.initializeChat();
      this.startMessagePolling();
    }
  },
  beforeUnmount() {
    this.cleanupChat();
  },
  methods: {
    initializeChat() {
      if (this.scriptLoaded) {
        console.warn("TalkdeskChatSDK script already loaded");
        this.initializeWebChat();
        return;
      }

      const script = document.createElement("script");
      script.src = "https://talkdeskchatsdk.talkdeskapp.com/talkdeskchatsdk.js";
      script.async = true;
      script.onload = () => {
        this.scriptLoaded = true;
        this.initializeWebChat();
      };

      document.body.appendChild(script);
    },
    initializeWebChat() {
      // eslint-disable-next-line no-undef
      this.webchat = TalkdeskChatSDK("tdWebchat", {
        touchpointId: this.$appConfig.talkDeskTouchpointId,
        accountId: "",
        region: "td-us-1",
      });

      this.webchat.init({
        enableEmoji: true,
        enableUserInput: true,
        enableAttachments: true,
        enableValidation: true,
        styles: this.chatStyles,
      });

      this.webchat.onConversationStart = this.setContext;
      this.webchat.onOpenWebchat = this.setContext;

      console.log("Webchat initialized");
    },
    setContext() {
      if (this.webchat) {
        this.webchat.setContextParam({
          contactid: this.salesforceContactId,
          td_contact_person_identification: this.userEmail,
        });
      }
    },
    startMessagePolling() {
      this.pollingInterval = setInterval(this.checkForNewMessages, 2000);
    },
    checkForNewMessages() {
      const storedMessageIndex = localStorage.getItem("lastMessageIndex");
      const storedMessageFrom = localStorage.getItem("lastMessageFrom");

      if (storedMessageIndex && storedMessageIndex !== this.lastMessageIndex) {
        if (storedMessageFrom === "agent") {
          console.log("New message received from agent");
          this.playNotificationAudio();
        }

        this.lastMessageIndex = storedMessageIndex;
        sessionStorage.setItem("lastProcessedMessageIndex", this.lastMessageIndex);
      }
    },
    playNotificationAudio() {
      if (!this.isAudioPlaying) {
        this.isAudioPlaying = true;
        this.notificationAudio
          .play()
          .then(() => console.log("Notification sound played"))
          .catch((err) => console.error("Failed to play audio:", err))
          .finally(() => {
            setTimeout(() => {
              this.isAudioPlaying = false;
            }, 500);
          });
      }
    },
    cleanupChat() {
      console.log("Cleaning up chat");
      clearInterval(this.pollingInterval);

      if (this.webchat) {
        try {
          this.webchat.reset();
          console.log("Chat widget reset");
        } catch (error) {
          console.error("Error resetting webchat:", error);
        }
      }

      localStorage.removeItem("lastMessageIndex");
      localStorage.removeItem("lastMessageFrom");
    },

  
  },
};
</script>
